import { render, staticRenderFns } from "./profile-my.vue?vue&type=template&id=2f1e021d"
import script from "./profile-my.vue?vue&type=script&lang=js"
export * from "./profile-my.vue?vue&type=script&lang=js"
import style0 from "./profile-my.vue?vue&type=style&index=0&id=2f1e021d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports